import React from "react";
import ReuseModal from "../../../../components/fragment/modal/ReuseModal";
import "../../../../styles/dashboard/users/UserActivitiesIndex.css";
import {
  RazorCopyText,
  RazorDateTime,
  RazorGetValue,
  RazorImageFallback,
  RazorNumberFormat,
  RazorTextTrim,
  RazorToolTip,
} from "../../../../components/razor-reuse";
import { RazorReturnInitial } from "../../../../components/razor-reuse";
import { capitalizeFirstLetter } from "../../../../utils/Helper";

interface myComponentProps {
  onClose?: () => void;
  visible?: boolean;
  details?: any;
}

const ViewActivityModal = ({ onClose, visible, details }: myComponentProps) => {
  function arrayToString(arr: string[], separator: string = ", "): string {
    return arr.join(separator);
  }
  const getListUserRoleTable = (list: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) =>
        capitalizeFirstLetter(chi)?.replaceAll("_", " ")
      );

      return arrayToString(newList);
    }
  };

  const objectToViewList = [
    { key: "full_name", label: "Full Name", value: "" },
    { key: "activity_type", label: "User Activity", value: "" },
    { key: "email", label: "Email address", value: "" },
    { key: "activity_detail", label: "Activity Details", value: "" },
    {
      key: "role",
      label: details?.role?.length > 1 ? `Roles` : "Role",
      value: getListUserRoleTable(details?.role),
    },
    { key: "date", label: "Date", value: "", date: true },
  ];
  return (
    <>
      <ReuseModal
        title="User Activity Overview"
        // btnLabel="Send Invite"
        visible={visible}
        onClose={onClose}
        hideBtn
      >
        <div
          //   onClick={() => {
          //     console.log(details);
          //   }}
          className="user-activity-modal-index-wrap-box"
        >
          {/* .image box start  */}
          <div className="img-wrap">
            <RazorImageFallback className="img-box" url="">
              <div className="avatar-box">
                <span>{RazorReturnInitial(details?.full_name)}</span>
              </div>
            </RazorImageFallback>
            {/* <figure className="img-box">
              {ALL_ICONS?.default_profile_img}
            </figure> */}
          </div>
          {/* .image box end  */}
          {/* activity info wrap box start */}
          <div className="infor-wrap-box">
            {RazorGetValue(objectToViewList, details)?.map(
              (chi: any, idx: any) => {
                if (chi?.hide || !chi?.value) {
                  return <React.Fragment key={idx}></React.Fragment>;
                }
                return (
                  <div key={idx} className="label-value-box">
                    <p className="label">{chi?.label}:</p>
                    <div
                      className={`value ${
                        String(chi?.value)?.length > 25 && !chi?.date
                          ? "tooltip-hover-wrap"
                          : ""
                      }`}
                      style={{ color: chi?.color ? chi?.color : "" }}
                    >
                      {chi?.date ? (
                        <RazorDateTime date={chi?.value} hideAgo />
                      ) : chi?.amount ? (
                        chi?.copy ? (
                          <RazorCopyText
                            textToCopy={RazorNumberFormat(chi?.value, {
                              symbol: chi?.symbol,
                              numberAbbreviate: String(chi?.value)?.length > 8,
                            })}
                            reference={RazorNumberFormat(chi?.value, {
                              symbol: chi?.symbol,
                              numberAbbreviate: String(chi?.value)?.length > 8,
                            })}
                            outerCopy
                          />
                        ) : (
                          RazorNumberFormat(chi?.value, {
                            symbol: chi?.symbol,
                            numberAbbreviate: String(chi?.value)?.length > 8,
                          })
                        )
                      ) : chi?.copy ? (
                        <RazorCopyText
                          textToCopy={chi?.value}
                          reference={RazorTextTrim(chi?.value, 25)}
                          outerCopy
                        />
                      ) : (
                        RazorTextTrim(chi?.value, 25) || "---"
                      )}
                      <RazorToolTip
                        color="black-light"
                        text={chi?.value}
                        position={`top-center`}
                      />
                    </div>
                  </div>
                );
              }
            )}
          </div>
          {/* activity info wrap box end */}
        </div>
      </ReuseModal>
    </>
  );
};

export default ViewActivityModal;
